import { render, staticRenderFns } from "./oaAdvantages.vue?vue&type=template&id=093bad70&scoped=true&"
import script from "./oaAdvantages.vue?vue&type=script&lang=js&"
export * from "./oaAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./oaAdvantages.vue?vue&type=style&index=0&id=093bad70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093bad70",
  null
  
)

export default component.exports